import { RuleObject } from 'antd/es/form';
import { set } from 'lodash-es';
import { Schema } from 'yup';

export const getFormValidator = (schema: Schema): RuleObject => ({
  async validator({ field }: any, value) {
    await schema.validateSyncAt(field, set({}, field, value));
  },
});
